import Raven from 'raven-js';
import PortalIdParser from 'PortalIdParser';
import { fetchAllAssociationValues } from '../../values/api';
import { InMemoryCache } from '../InMemoryCache';
import { getCombinedAssociationTypeIdFromParts } from 'customer-data-objects/associations/AssociationCategoryTypes';
const toCacheKey = ({
  objectTypeId,
  objectId,
  toObjectTypeIds
}) => `${objectTypeId}/${objectId}/${toObjectTypeIds.join(',')}`;
const fetcher = (key, promiseClient) => {
  const {
    objectTypeId,
    objectId,
    toObjectTypeIds
  } = key;
  if (!toObjectTypeIds.length) {
    Raven.captureException(new Error('Invalid request: Fetched associations with empty toObjectTypeIds'), {
      extra: {
        objectTypeId,
        objectId,
        portalId: PortalIdParser.get()
      }
    });
    return Promise.resolve({});
  }
  return fetchAllAssociationValues(+objectId, objectTypeId, toObjectTypeIds, promiseClient).then(res => {
    const cachedValues = res.reduce((acc, associationToObjectType) => {
      const {
        results
      } = associationToObjectType;
      results.results.forEach(result => {
        result.associationTypes.forEach(associationType => {
          var _acc$combinedAssociat;
          const combinedAssociationTypeId = getCombinedAssociationTypeIdFromParts(associationType.associationCategory, associationType.associationTypeId);
          const existingValues = ((_acc$combinedAssociat = acc[combinedAssociationTypeId]) === null || _acc$combinedAssociat === void 0 ? void 0 : _acc$combinedAssociat.value) || [];
          acc[combinedAssociationTypeId] = {
            value: [...existingValues, result.objectId],
            hasMore: results.hasMore
          };
        });
      });
      return acc;
    }, {});
    return cachedValues;
  });
};
export const makeAssociationValuesCache = () => new InMemoryCache('AssociationValuesCache', fetcher, toCacheKey);